var __TEMP__ = require('./_baseGetTag.js');var baseGetTag = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isObjectLike.js');var isObjectLike = __REQUIRE_DEFAULT__(__TEMP__);

var arrayBufferTag = '[object ArrayBuffer]';

/**
 * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
 */
function baseIsArrayBuffer(value) {
  return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = baseIsArrayBuffer;
